import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57724a22"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "map_trail" }, null, -1))
const _hoisted_2 = { class: "search" }
const _hoisted_3 = { class: "expand-box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_5 = { class: "buttom" }
const _hoisted_6 = { class: "left" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "auto-text ws_ml4" }, "自动刷新", -1))
const _hoisted_8 = { class: "right" }
const _hoisted_9 = { class: "data" }
const _hoisted_10 = { class: "data-operation" }

import { ref, onMounted, onUnmounted, watch, computed, nextTick } from 'vue'
import { createPopup, createMap, formatLat, formatLng } from '@/utils/map.utils'
import { CODE_ENUM } from '@/common/enum'
import { ElMessage } from 'element-plus'
import {  queryAllDevice, queryDevicePlayback } from '@/api'
import MapControl from '@/components/map-control'
import moment from 'moment'
import { cloneDeep, isEmpty, throttle } from 'lodash'
import TrailData from './component/trail-data.vue'
import AddPoint from './component/add-point.vue'
import { useMapStore } from '@/stores/map'
import L from 'leaflet'
import PlayBar from './component/play-bar.vue'
import '@/utils/animatedMarker'
import SelectTenant from '@/components/select-tenant'
import SelectDevice from '@/components/select-device'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const mapStore = useMapStore()

const isExpand = ref(false)
const expand = () => {
  isExpand.value = !isExpand.value
}

const isPlay = ref(false)
const toSetPlayStatus = (status: boolean) => {
  isPlay.value = status
  if (status) {
    playRef.value?.removeTrail?.()
    playRef.value?.drawTrail(moDeviceInfo.value)
  }
}

const getDate = (month: number, unit: any) => {
  const current = moment().format('YYYY-MM-DD')
  const preDate = moment(current).subtract(month, unit).format('YYYY-MM-DD')
  return [
    new Date(moment(preDate + ' 00:00:00').valueOf()),
    new Date(moment(current + ' 23:59:59').valueOf()),
  ]
}
const shortcuts = [
  {
    text: '今天',
    value: getDate(1, 'D'),
  },
  {
    text: '最近一个月',
    value: getDate(1, 'M'),
  },
  {
    text: '最近三个月',
    value: getDate(3, 'M'),
  },
  {
    text: '最近半年',
    value: getDate(6, 'M'),
  },
]

const advancedRef = ref()

const form: any = ref({
  deviceId: '',
  time: getDate(1, 'M'),
})

const timeValidator = (rule: any, value: any, callback: any) => {
  if (isEmpty(value)) {
    callback('请选择时间范围')
  } else {
    const [start, end] = value
    if (
      moment(end).valueOf() - moment(start).valueOf() >
      1000 * 60 * 60 * 24 * 367
    ) {
      callback('时间跨度要小于一年')
    } else {
      callback()
    }
  }
}
const rules: any = {
  deviceId: { required: true, message: '请选择设备' },
  time: [{ validator: timeValidator }],
}

const resetForm = () => {
  moFormData.value = {}
  advancedRef.value.resetFields()
  clearAllMarker()
  playRef.value?.removeTrail?.()
  queryDeviceLocation()
}

// 用于缓存查询的条件
const moFormData: any = ref({})
const submit = () => {
  advancedRef.value.validate((valid: boolean) => {
    if (valid) {
      moFormData.value = cloneDeep(form.value)
      queryDeviceTrail()
    }
  })
}

const playRef = ref()
const moDeviceInfo = ref({})

const submitLoading = ref(false)
const trailData = ref([])
const queryDeviceTrail = async () => {
  const { deviceId, time } = form.value
  const [start, end] = time
  submitLoading.value = true
  const res: any = await queryDevicePlayback({
    deviceId,
    startTime: moment(start).valueOf(),
    endTime: moment(end).valueOf(),
  }).finally(() => {
    submitLoading.value = false
    playRef.value?.removeTrail?.()
  })

  if (res?.code === CODE_ENUM.SUCCESS) {
    // clearOtherMarker(deviceId)
    clearAllMarker()

    const locusDatas = res.data?.deviceLocusInfos?.[0]?.locusDatas || []
    const deviceInfo = res.data?.deviceLocusInfos?.[0]?.deviceInfo

    const reverseData = locusDatas
    trailData.value = reverseData

    if (reverseData.length === 0) {
      const latlng = new L.LatLng(22.646419, 114.090136)
      map.panTo(latlng)
      map.setView(latlng, 6)
      ElMessage.warning('当前时间段内暂无设备定位信息')
      return
    }
    moDeviceInfo.value = deviceInfo
    nextTick(() => {
      playRef.value.drawTrail(deviceInfo)
    })
  }
}

let map: any = null
let layerInstance: any = null

const getMap = () => {
  return map
}
onMounted(async () => {
  map = createMap('map_trail')

  layerInstance = mapStore.layerInstance

  // queryDevice()
  queryDeviceLocation()

  map.on('zoomend', () => {
    throttleZoomend()
  })
})

const zoomendMethod = () => {
  const trailEntity = playRef.value?.getTrailEntity?.() || []
  const result = markerEntity.value.concat(trailEntity)
  result.map((marker: any) => {
    const latLng = marker?.getLatLng?.()
    marker?.setLatLng?.(latLng)
  })
}

const throttleZoomend = throttle(zoomendMethod, 1000)

const onOrgChange = () => {
  form.value.deviceId = ''
}

const markerEntity: any = ref([])
// 移除所有设备
const clearAllMarker = () => {
  markerEntity.value.forEach((marker: any) => {
    marker.entity.remove()
  })
}
// 移除其他
const clearOtherMarker = (deviceId: string) => {
  markerEntity.value.forEach((marker: any) => {
    if (marker.id !== deviceId) {
      marker.entity.remove()
    } else {
      marker.entity.addTo(map)
    }
  })
}

// 设备列表
const deviceList: any = ref([])
const queryDeviceLocation = async () => {
  const res: any = await queryAllDevice()
  if (res?.code === CODE_ENUM.SUCCESS) {
    deviceList.value = res?.data || []
    createDeviceMaker()

    if (deviceList.value.length === 0) {
      toChina()
    }
  } else {
    toChina()
  }
}

const toChina = () => {
  const latlng = new L.LatLng(34.16793, 107.3863)
  map.panTo(latlng)
  map.setView(latlng, 5)
}

// 渲染设备
const createDeviceMaker = () => {
  clearAllMarker()
  markerEntity.value = []
  deviceList.value.forEach((device: any) => {
    const marker: any = createMarker(device)
    marker.addTo(map)
    markerEntity.value.push({
      id: device.deviceId,
      entity: marker,
    })
  })
  if (autoFetch.value) {
    moFormData.value?.deviceId && clearAllMarker()
    return
  }
  if (deviceList.value.length !== 0 || !autoFetch.value) {
    map.fitBounds(getPoints(deviceList.value))
  }
}

const createMarker = (device: any) => {
  const { latitude, longitude, picCode } = device
  const marker = L.marker([latitude, longitude], {
    icon: new L.divIcon({
      iconSize: [49, 62],
      iconAnchor: [25, 60],
      className: 'map-' + picCode,
    }),
  })
  const popup = createPopup(device)

  marker.bindPopup(popup)
  marker.off('click')
  marker.on('click', async (e: any) => {
    const { latlng } = e
    popup.setContent(`
      <div>设备名称：${device.deviceName}</div>
      <div>设备地址：${device.deviceAddress || '-'}</div>
      <div>纬度：${
        formatLat(device.latitude) + ' ' + device.latitude + '°'
      }</div>
      <div>经度：${
        formatLng(device.longitude) + ' ' + device.longitude + '°'
      }</div>
      <div style="padding-bottom: 6px;">时间：${moment(
        device.updateTime
      ).format('YYYY-MM-DD HH:mm:ss')}</div>
    `)
    // map.panTo(latlng)
    // map.setView(latlng, 13)
    marker.openPopup()
  })

  return marker
}

// 获取点
const getPoints = (points: any) => {
  return points.map((device: any) => {
    const { longitude, latitude } = device
    return {
      lng: longitude,
      lat: latitude,
    }
  })
}

// 处理一下时间
const dealwithTime = () => {
  if (form.value.time.length === 2) {
    const now = moment().valueOf()
    const endTime = moment(form.value.time[1]).valueOf()
    if (now > endTime) {
      form.value.time[1] = new Date()
    }
  }
}

// 自动刷新
const autoFetch = ref(false)
const timer: any = ref(0)
watch(autoFetch, () => {
  if (autoFetch.value) {
    clearInterval(timer.value)
    timer.value = setInterval(() => {
      dealwithTime()
      submit()
      queryDeviceLocation()
    }, 1000 * 15)
  } else {
    clearInterval(timer.value)
  }
})

onUnmounted(() => {
  clearInterval(timer.value)
})

// 轨迹表格详情
const detailConf = ref({
  visible: false,
  data: {},
})

const showDetail = () => {
  detailConf.value = {
    visible: true,
    data: moFormData.value,
  }
}

const onAddPontSuccess = async () => {
  submit()
  await queryDeviceLocation()
  setTimeout(() => {
    // clearOtherMarker(moFormData.value?.deviceId)
    clearAllMarker()
  }, 0)
}
const mapConf = ref({
  visible: false,
  data: {},
})
const toShowMap = () => {
  mapConf.value = {
    visible: true,
    data: cloneDeep(moFormData.value),
  }
}

const onMapTypeChange = (url: any) => {
  layerInstance.setUrl(url)
}

const speed = ref(1)
const setSpeed = (value: number) => {
  speed.value = value
}

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_InfoFilled = _resolveComponent("InfoFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["trail-page", { 'play-mode': isPlay.value }])
    }, [
      _hoisted_1,
      _createVNode(_unref(MapControl), {
        onOnChange: onMapTypeChange,
        clearable: ""
      }),
      _createElementVNode("div", {
        class: _normalizeClass(["search-box", isExpand.value ? 'search-expand-in' : 'search-expand-out'])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              onClick: expand,
              class: "expand"
            }, [
              _createElementVNode("span", null, _toDisplayString(!isExpand.value ? '收起' : '展开'), 1),
              _hoisted_4
            ])
          ]),
          _createVNode(_component_el_form, {
            model: form.value,
            rules: rules,
            "hide-required-asterisk": "",
            "label-width": "80px",
            ref_key: "advancedRef",
            ref: advancedRef
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "组织名称",
                prop: "orgId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(SelectTenant), {
                    style: {"width":"100%"},
                    class: "ws_select_form",
                    modelValue: form.value.orgId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.orgId) = $event)),
                    onChange: onOrgChange,
                    clearable: "",
                    "show-type": true
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "设备名称",
                prop: "deviceId",
                class: "form-item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(SelectDevice), {
                    modelValue: form.value.deviceId,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.deviceId) = $event)),
                    orgId: form.value.orgId
                  }, null, 8, ["modelValue", "orgId"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "时间",
                prop: "time",
                class: "form-item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: form.value.time,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.time) = $event)),
                    "unlink-panels": "",
                    type: "datetimerange",
                    "range-separator": "-",
                    "start-placeholder": "开始时间",
                    "end-placeholder": "结束时间",
                    shortcuts: shortcuts,
                    editable: false
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_el_switch, {
                    modelValue: autoFetch.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((autoFetch).value = $event))
                  }, null, 8, ["modelValue"]),
                  _hoisted_7,
                  _createVNode(_component_el_tooltip, {
                    class: "box-item",
                    effect: "dark",
                    content: "每十五秒自动点击查询按钮一次",
                    placement: "top"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, { class: "ws_ml10" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_InfoFilled)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_el_button, { onClick: resetForm }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 重置")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    onClick: submit,
                    loading: submitLoading.value,
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("查询")
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["model"]),
          _withDirectives(_createElementVNode("div", _hoisted_9, [
            _createVNode(_component_el_button, {
              onClick: toShowMap,
              class: "ws_mr16",
              plain: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode("添加轨迹点")
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_el_button, {
                disabled: autoFetch.value || trailData.value.length <= 1,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (toSetPlayStatus(true))),
                type: "primary",
                class: "ws_mr16"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("播放轨迹")
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_el_button, {
                onClick: showDetail,
                plain: "",
                disabled: trailData.value.length === 0
              }, {
                default: _withCtx(() => [
                  _createTextVNode("轨迹详情")
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ], 512), [
            [_vShow, 
            moFormData.value.deviceId &&
            (!submitLoading.value || autoFetch.value || !_unref(isEmpty)(moFormData.value))
          ]
          ])
        ])
      ], 2),
      _createVNode(PlayBar, {
        ref_key: "playRef",
        ref: playRef,
        getMap: getMap,
        trailData: trailData.value,
        isPlay: isPlay.value,
        speed: speed.value,
        onExit: toSetPlayStatus,
        onSetSpeed: setSpeed
      }, null, 8, ["trailData", "isPlay", "speed"])
    ], 2),
    _createVNode(TrailData, {
      visible: detailConf.value.visible,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((detailConf.value.visible) = $event)),
      data: detailConf.value.data,
      getMap: getMap
    }, null, 8, ["visible", "data"]),
    _createVNode(AddPoint, {
      visible: mapConf.value.visible,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((mapConf.value.visible) = $event)),
      data: mapConf.value.data,
      onSuccess: onAddPontSuccess
    }, null, 8, ["visible", "data"])
  ], 64))
}
}

})